import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";

const useProfile = () => {
  const [loading, setLoading] = useState(true);
  const [userProfile, setUserProfile] = useState<any>(null);
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const checkAuth = () => {
      try {
        // Get user profile session using existing helper
        const userProfileSession = getLoggedinUser();
        
        // Get authToken directly from localStorage
        const authToken = localStorage.getItem('authToken');
        
        console.log('useProfile - userProfileSession:', userProfileSession);
        console.log('useProfile - authToken:', authToken);
        
        if (userProfileSession && authToken && 
            authToken !== '' && authToken !== 'null' && authToken !== 'undefined') {
          setUserProfile(userProfileSession);
          setToken(authToken); // Use authToken from localStorage instead of nested token
          setLoading(false);
        } else {
          setUserProfile(null);
          setToken(null);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error in useProfile:", error);
        setUserProfile(null);
        setToken(null);
        setLoading(false);
      }
    };

    checkAuth();
    
    // Listen for storage changes to re-check auth
    const handleStorageChange = () => {
      checkAuth();
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return { userProfile, loading, token };
};

export { useProfile };